<template>
   <div class="layout-page">
      <h1>Send a Recruitment Invitation</h1>

      <form class="mart-24 container-fluid">
         <div class="form-group row">
            <label for="firstName" class="col-6 col-sm-6 col-md-4 col-lg-3 col-form-label"
               >Prospect First Name</label
            >
            <div class="col-6">
               <input
                  type="text"
                  class="form-control"
                  v-model="firstName"
                  placeholder="First Name"
                  required
                  @keyup="merge"
                  :readonly="this.existingInvite"
               />
            </div>
         </div>
         <div class="form-group row">
            <label for="lastName" class="col-6 col-sm-6 col-md-4 col-lg-3 col-form-label"
               >Prospect Last Name</label
            >
            <div class="col-6">
               <input
                  type="text"
                  class="form-control"
                  v-model="lastName"
                  placeholder="Last Name"
                  required
                  @keyup="merge"
                  :readonly="this.existingInvite"
               />
            </div>
         </div>
         <div class="form-group row">
            <label for="emailAddress" class="col-6 col-sm-6 col-md-4 col-lg-3 col-form-label"
               >Prospect Email Address</label
            >
            <div class="col-sm-6">
               <input
                  type="text"
                  class="form-control"
                  v-model="emailAddress"
                  placeholder="Email Address"
                  required
               />
            </div>
         </div>
         <div class="form-group row">
            <label for="ccEmailAddress" class="col-6 col-sm-6 col-md-4 col-lg-3 col-form-label"
               >CC Email Address</label
            >
            <div class="col-sm-6">
               <input
                  type="text"
                  class="form-control"
                  v-model="ccEmailAddress"
                  placeholder="CC Email Address"
                  required
               />
            </div>
         </div>
         <div class="form-group row" v-if="existingInvite">
            <label for="invitedTo" class="col-6 col-sm-6 col-md-4 col-lg-3 col-form-label"
               >Previously Invited On</label
            >
            <div class="col-sm-6">
               <input type="text" readonly class="form-control-plaintext" v-model="inviteDate" />
            </div>
         </div>
         <div class="form-group row">
            <label for="invitedTo" class="col-6 col-sm-6 col-md-4 col-lg-3 col-form-label"
               >Invited To</label
            >
            <div class="col-sm-6">
               <input type="text" readonly class="form-control-plaintext" v-model="invitedTo" />
               <input type="text" readonly class="form-control-plaintext under" v-model="under" />
            </div>
         </div>
         <div class="form-group row">
            <label for="inputEmail" class="col-6 col-sm-6 col-md-4 col-lg-3 col-form-label"
               >Invitation Email Template</label
            >
            <div class="col-sm-6">
               <select class="form-control" 
                  v-model="emailTemplateId" 
                  @change="templateChanged($event)"
                  :readonly="this.existingInvite" :disabled="this.existingInvite"
               >
                  <option v-for="(t, indx) in templates" :value="t.corrTemplateId" :key="indx">{{t.name=='DFT_MLT_INVITE' ? "Default Invitation" : t.name}}</option>
               </select>
            </div>
         </div>
      </form>

      <div class="container-fluid">
         <h3>Invitation Email</h3>

         <div class="row font-smaller">
            <div class="col-12 col-md-10">
               <editor-menu :editor="editor" class="editor-menu-window" />
               <editor-content :editor="editor" class="editor-window" />

               <div class="text-right">
                  <button
                     type="button"
                     class="btn ml-btn ml-bk-black ml-h-corp ml-white mart-12 marb-12 marr-12 btnw"
                     @click.prevent="handleCancel"
                  >
                     <i class="fas fa-spinner fa-spin" v-if="saving"></i>
                     <span v-else>
                        <i class="fas fa-times"></i>
                        CANCEL
                     </span>
                  </button>
                  <button
                     type="button"
                     class="btn ml-btn ml-bk-corp ml-white mart-12 marb-12 btnw"
                     @click.prevent="handleSave"
                  >
                     <i class="fas fa-spinner fa-spin" v-if="saving"></i>
                     <span v-else>
                        <i class="fas fa-paper-plane"></i>
                        SEND
                     </span>
                  </button>
               </div>
            </div>
         </div>
      </div>
      
   </div>
</template>

<script>
import moment from 'moment'
import { Editor, EditorContent, EditorMenuBar } from '@tiptap/vue-2'
import EditorMenu from "@/components/EditorMenu";
import StarterKit from '@tiptap/starter-kit'
import HardBreak from '@tiptap/extension-hard-break'
import Link from '@tiptap/extension-link'
import Table from '@tiptap/extension-table'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'
import CustomImage from '../assets/js/custom-image'
import Code from '@tiptap/extension-code'


export default {
   name: "Protected",
   components: {
      EditorContent,
      "editor-menu": EditorMenu,
   },
   props: {
      linkData : {
         type: Object
      }
   },
   data() {
      return {
         userId: this.$store.getters.appUser.userId,
         templates: [],
         existingInvite: false,
         existing: {},
         templateContent: '',
         saving: false,
         firstName: '',
         lastName: '',
         emailAddress: '',
         ccEmailAddress: '',
         invitedTo: '',
         under: '',
         emailTemplateId: 3,
         recruiter: {},
         requester: {},
         linkRec: {},
         link: '',
         multiLink: '',
         inviteDate: '',
         multiLinkPrefix: 'MLT',
         prefix: `
<html><head><style>
   body {
      font-family: Calibri, Arial, Helvetica, sans-serif;
      font-size: medium;
   }
   .name {
      font-weight: bold;
   }

   .table {
      border: 1px solid #ccc;
      padding: 3px;
      border-spacing: 0;
      border-collapse: collapse;
   }

   th,
   td {
      padding: 6px;
   }

   th,
   td.h {
      background-color: #eee;
      font-weight: bold;
   }

   td.d {
      font-family: courier, courier new, Lucida Console, serif;
   }
   .custom-image-small {
      max-width: 60px;
      width: 60px;
   }

   .custom-image-medium {
      max-width: 300px;
      width: 300px;
   }

   .custom-image-large {
      max-width: 100%;
   }
</style></head><body>`,
         suffix: 
`</body></html>`,
         editor: null,
      };
   },
   created() {
      this.editor = new Editor({
         content: '',
         extensions: [
            StarterKit.configure({
               hardBreak: false,
               code: false
            }),
            HardBreak.extend({
               addKeyboardShortcuts() {
                  return {
                        Enter: () => {
                           if (this.editor.isActive('orderedList') || this.editor.isActive('bulletList')) {
                              return this.editor.chain().createParagraphNear().run();
                           }
                           return this.editor.commands.setHardBreak();
                        },
                  };
               },
            }),
            Link.configure({
               linkOnPaste: false,
            }),
            Code.configure({
               HTMLAttributes: {
                  class: 'code-field',
               },
            }),
            CustomImage.configure({
               HTMLAttributes: {
                  class: 'custom-image'
               }
            }),
            Table.configure({
               resizable: true,
            }),
            TableRow,
            TableHeader,
            TableCell
         ]
      })
   },
   async mounted() {
      this.$parent.loadingStart()
      await this.fetchTemplates()

      //Validate inbound parameters
      if (!this.$route.params.link && !this.$route.params.links && !this.$route.params.recruiter && !this.$route.params.id && !this.$route.params.existing) {
         this.$swal(
            "Invite Who, What, Where?",
            "Some invite data was missing. Please try again.",
            "error"
         ).then(() => {
            this.$router.push({ name: 'linx' })
            return
         })
      }

      if (this.$route.params.existing) { // Open existing invitation
         this.existingInvite = true
         this.existing = this.$route.params.existing

         await this.loadExisting()

      } else { // Create NEW invitation
         this.existingInvite = false
         this.recruiter = this.$route.params.recruiter
         this.requester = this.$route.params.req
         if (this.$route.params.links) {
            await this.createMultipleInvite()
         } else {
            await this.createSingleInvite()
         }
      }
      
      this.$parent.loadingEnd()
   },
   computed: {
      showHtml() {
         return this.editor.getHTML()
      },
   },
   methods: {
      async fetchTemplates() {
         await this.$template.listUserTemplates("CORTYP_MLT_INVITE", this.userId)
            .then(async (r) => {
               if (r) {
                  this.templates = r
               } 
            })
            .catch(err => {
               this.$swal(
                  "System Error",
                  "Oops! Some unforseen system error occurred while trying to retrieve templates. Please try again later. If this problem persists please contact support.",
                  "error"
               );
            })
      },
      async createSingleInvite() {
         this.linkRec = this.$route.params.link

         if (this.linkRec.schedRec === undefined || this.linkRec.schedRec.extDocumentId == null || this.linkRec.schedRec.extDocumentId == '') {
            this.$swal(
               "Schedule Doc Unavailable",
               "The administrators have not finished configuring this commission schedule with the appropriate documents. Please complete that or contact support if neccessary.",
               "error"
            ).then(() => {
               this.$router.push({ name: 'linx' })
               return
            })
         }
         this.invitedTo = `Level ${this.linkRec.schedRec.levelNo} - ${this.linkRec.schedRec.levelName}`
         this.under = `Starting Under Agent Number ${this.requester.agentNumber}`

         await this.fetchTemplateContent()
         this.mergeContent()
      },
      async createMultipleInvite() {
         this.invitedTo = 'Multiple Appointments (See Email)'
         let linx = []

         for (let i = 0; i < this.$route.params.links.length; i++) {
            let lr = this.$route.params.links[i]
            if (lr.schedRec === undefined || lr.schedRec.extDocumentId == null || lr.schedRec.extDocumentId == '') {
               this.$swal(
                  "Schedule Doc Unavailable",
                  "The administrators have not finished configuring one of the commission schedules you've chosen. Please contact support to complete the neccessary configuration.",
                  "error"
               ).then(() => {
                  this.$router.push({ name: 'linx' })
                  return
               })
            }
            linx.push(lr.linkRec.link)
         }

         // We need to create and return the new MultiLinkId
         let payload = { //CreateMultiRequestDTO
            appointmentLinks: linx,
            createdById: this.$store.getters.appUser.userId.toUpperCase()
         }
         await this.$appoint.createMulti(payload)
         .then(async (r) => {
            if (!r) {
               this.$swal(
                  "System Error",
                  "Oops! Some unforseen system error occurred while trying to create the application. Please try again later. If this problem persists please contact support.",
                  "error"
               );
               this.$router.push({ name: 'linx' })
            } 
            // r contains the link
            this.multiLink = r.multiLink
         })
         .catch(err => {
            this.$swal(
               "System Error",
               "Oops! Some unforseen system error occurred while trying to create the application. Please try again later. If this problem persists please contact support.",
               "error"
            );
            this.$router.push({ name: 'linx' })
         })

         this.under = `Starting Under Agent Number ${this.requester.agentNumber}`

         // Use the MULTILINK template instead
         this.emailTemplateId = 8
         await this.fetchTemplateContent()
         this.merge()
      },
      async loadExisting() {
         await this.$appoint.getInvite(this.existing.invitationId)
         .then(async (r) => {
            if (!r) {
               this.$swal(
                  "Oops!",
                  "Some system error occured while trying to retrieve an existing invitation. If this problem persists, please contact support.",
                  "error"
               );
               return;
            }
            this.firstName = r.prospectFirstName
            this.lastName = r.prospectLastName
            this.emailAddress = r.prospectEmailAddress
            this.userId = r.prospectUserId
            this.ccEmailAddress = r.ccEmailAddress
            this.emailTemplateId = r.corrEmailTemplateId
            this.editor.commands.setContent(r.inviteText, false)
            this.under = `Starting Under Agent Number ${r.inviterAgentNumber}`
            this.inviteDate = moment(String(r.inviteDate), moment.ISO_8601).format('dddd, MMM D, YYYY')
            await this.loadApptLevel(r.appointmentLinkId, r)
            this.requester = {
               agentNumber: r.inviterAgentNumber,
               companyNumber: r.inviterCompanyNumber.toString(),
               blockNumber: r.inviterBlockNumber.toString()
            }
         })
         .catch((err) => {
            // log err
         })
      },
      async loadApptLevel(linkId, invite) {
         if (invite.inviteTypeCode == "INVTYP_MULTI") {
            //MultiLink invite
            this.invitedTo = '(Multiple Appointments)'
            this.link = invite.multiLink
         } else {
            // Single Invite
            await this.$appoint.getLink(linkId)
            .then((r) => {
               if (!r) {
                  this.$swal(
                     "Appointment Link Not Found",
                     "The previously sent appontment link was not found and may have been disabled. If you think you've reached this impass in error, please contact "+process.env.VUE_APP_MKT_EMAIL+".",
                     "warning"
                  );
                  this.$router.push({ name: 'invites' })
                  return;
               }
               this.invitedTo = `Level ${r.levelNo} - ${r.levelName}`
               this.link = r.link
            })
            .catch((err) => {
               // log err
            })
         }
      },
      async fetchTemplateContent() {
         await this.$appoint.getTemplate(this.emailTemplateId)
         .then((r) => {
            if (!r) {
               this.$swal(
                  "Oops!",
                  "Some system error occured and the email template could not be retrieved. If this problem persists, please contact support.",
                  "error"
               );
               return;
            }
            this.templateContent = r
         })
         .catch((err) => {
            // log err
         })
      },
      async handleCancel() {
         if (this.existingInvite) {
            this.$router.push({ name: 'invites' })
         } else {
            this.$router.push({ name: 'linx' })
         }
      },
      async handleSave() {
         if (this.firstName=='' || this.lastName=='' || this.emailAddress=='') {
            this.$swal(
               "Oops!",
               "All fields except for 'CC Email Address' need to be filled in before we can send the email.",
               "error"
            )
            return
         }
         this.$swal({
            title: 'Are you sure?',
            text: "This will send an email to the specified recipients.\nPlease confirm...",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#00a7a1',
            confirmButtonText: 'YES, SEND IT!',
            cancelButtonColor: '#000',
            cancelButtonText: '<i class="fas fa-times"></i> CANCEL'
            })
         .then(async (result) => {
            if (result.isConfirmed) {
               this.saving = true
               await this.sendEmail()
               this.saving = false
            }
         })
      },
      async sendEmail() {
         // save and send invitation
         var cnt = this.prefix + this.editor.getHTML() +  this.suffix;
         var payload = {}
         if (this.existingInvite) {
            payload = {
               link: this.link, 
               firstName: this.firstName,
               lastName: this.lastName,
               emailAddress: this.emailAddress,
               ccEmailAddress: this.ccEmailAddress,
               recruiterAgentNo: this.requester.agentNumber, 
               recruiterCompanyNo: this.requester.companyNumber, 
               recruiterBlockNo: this.requester.blockNumber, 
               emailTemplateId: this.emailTemplateId,
               emailContent: cnt,
               userId: this.$store.getters.appUser.userId
            }
         } else {
            let lnk = ''
            if (this.$route.params.links) {
               lnk = this.multiLink
            } else {
               lnk = this.linkRec.linkRec.link
            }

            payload = {
               link: lnk,
               firstName: this.firstName,
               lastName: this.lastName,
               emailAddress: this.emailAddress,
               ccEmailAddress: this.ccEmailAddress,
               recruiterAgentNo: this.requester.agentNumber,
               recruiterCompanyNo: this.requester.companyNumber,
               recruiterBlockNo: this.requester.blockNumber,
               emailTemplateId: this.emailTemplateId,
               emailContent: cnt,
               userId: this.$store.getters.appUser.userId
            }
         }
         await this.$appoint.sendInvitation(payload)
         .then((r) => {
            if (!r || r == false) {
               this.$swal(
                  "Oops!",
                  "Some system error failed and the invitation was not sent. If this problem persists, please contact support.",
                  "error"
               );
               return;
            }
            this.$nextTick(() => {
               this.$swal(
                  'Sent!',
                  'Your invitation has been sent. If you\'ve copied yourself, it may take up to 20 minutes to get to you.',
                  'success'
               )
               this.$router.push({ name: 'invites' })
            })
         })
         .catch((err) => {
            // log err
         })
      },
      titleCase(sentence) {
         if (sentence == null) return ''
         sentence = sentence.replace(/  +/g, ' ') //remove any double spaces
         const words = sentence.trim().toLowerCase().split(" ")
         return words.map((word) => { 
            return word[0].toUpperCase() + word.substring(1); 
         }).join(" ")
      }, 
      cleanDoc(pth) {
         let pos = pth.indexOf('\\');
         return pth.substr(pos + 1) // cut off the folder name in front
      },
      async templateChanged(event) {
         this.busy = true
         await this.fetchTemplateContent()
         this.merge()
         this.busy = false
      },
      merge() {
         if (this.existingInvite) return;
         let content = this.templateContent
         const url = process.env.VUE_APP_URL

         //--------------------------------legacy merge fields

         //[[LINK_ROW]]
         let linkRow = ''
         let baseCol = []
         for (let i = 0; i < this.$route.params.links.length; i++) {
            let lr = this.$route.params.links[i]
            if (lr.isBase === undefined || 
               lr.isBase == false ||
               !baseCol.includes(lr.schedHeaderId)) 
            {
               let doc = encodeURIComponent(lr.schedRec.extDocumentId)
               let docLink = `<a href='${url + '/view/' + doc}' target='_blank'>Click here to download your commission schedule for ${this.cleanDoc(lr.schedRec.extDocumentId)}</a>`
               linkRow += `<tr><td>${lr.schedRec.levelNo}</td><td>${lr.schedRec.levelName}</td><td>${docLink}</td></tr>`

               if (lr.isBase == true) {
                  baseCol.push(lr.schedHeaderId)
               }
            }
         }
         content = content.replace(/\[\[LINK_ROW\]\]/gi, linkRow)

         // ------------------------------configured merge fields
         // [[HTML_APPT_LINK]]
         let output = `<a href='${url + '/' + this.multiLinkPrefix + this.multiLink}' target='_blank'>${url + '/' + this.multiLinkPrefix + this.multiLink}</a>`
         content = content.replace(/\[\[HTML_APPT_LINK\]\]/gi, output)

         // [[HTML_DOC_LINKS]]
         output = ''
         linkRow = ''
         baseCol = []
         for (let i = 0; i < this.$route.params.links.length; i++) {
            let lr = this.$route.params.links[i]
            if (lr.isBase === undefined || 
               lr.isBase == false ||
               !baseCol.includes(lr.schedHeaderId)) 
            {
               let doc = encodeURIComponent(lr.schedRec.extDocumentId)
               output += `&nbsp;&nbsp;<a href='${url + '/view/' + doc}' target='_blank'>${this.cleanDoc(lr.schedRec.extDocumentId)}</a>`
               if (i != (this.$route.params.links.length-1)) {
                  output += `<br />`
               }

               if (lr.isBase == true) {
                  baseCol.push(lr.schedHeaderId)
               }
            }
         }
         content = content.replace(/\[\[HTML_DOC_LINKS\]\]/gi, output)

         // [[PROSPECT_FIRST_NAME]]
         content = content.replace(/\[\[PROSPECT_FIRST_NAME\]\]/gi, this.firstName)

         // [[PROSPECT_LAST_NAME]]
         content = content.replace(/\[\[PROSPECT_LAST_NAME\]\]/gi, this.lastName)

         // [[APPOINTMENT_LINK]] - raw link
         content = content.replace(/\[\[APPOINTMENT_LINK\]\]/gi, url + '/' + this.multiLinkPrefix + this.multiLink)

         // [[DOCUMENT_LINKS]] - raws links with a BR after each link
         output = ''
         linkRow = ''
         baseCol = []
         for (let i = 0; i < this.$route.params.links.length; i++) {
            let lr = this.$route.params.links[i]
            if (lr.isBase === undefined || 
               lr.isBase == false ||
               !baseCol.includes(lr.schedHeaderId)) 
            {
               let doc = encodeURIComponent(lr.schedRec.extDocumentId)
               output += `${url + '/view/' + doc}`
               if (i != (this.$route.params.links.length-1)) {
                  output += `<br />`
               }
               if (lr.isBase == true) {
                  baseCol.push(lr.schedHeaderId)
               }
            }
         }
         content = content.replace(/\[\[DOCUMENT_LINKS\]\]/gi, output)
         content = content.replace(/\[\[DOCUMENT_LINK\]\]/gi, output)

         // [[RECRUITER_AGENCY_NAME]]
         content = content.replace(/\[\[RECRUITER_AGENCY_NAME\]\]/gi, this.titleCase(this.recruiter.businessName) ?? '')

         // [[RECRUITER_NAME]]
         if (this.recruiter.businessName == null || this.recruiter.businessName == '')
         {
            content = content.replace(/\[\[RECRUITER_NAME\]\]/gi, this.titleCase(this.recruiter.name) ?? '')
         } else {
            content = content.replace(/\[\[RECRUITER_NAME\]\]/gi, this.titleCase(this.recruiter.businessName))
         }

         // [[RECRUITER_EMAIL_ADDRESS]]
         content = content.replace(/\[\[RECRUITER_EMAIL_ADDRESS\]\]/gi, this.recruiter.emailAddress ?? '')

         
         // --------------------------Personal Info
         // [[RECRUITER_ADDRESS1]]
         // [[RECRUITER_ADDRESS2]]
         // [[RECRUITER_CITY]]
         // [[RECRUITER_STATECODE]]
         // [[RECRUITER_ZIPCODE]]         
         content = content.replace(/\[\[RECRUITER_ADDRESS1\]\]/gi, this.recruiter.address1 ?? '')
         content = content.replace(/\[\[RECRUITER_ADDRESS2\]\]/gi, this.recruiter.address2 + '<br/>' ?? '')
         content = content.replace(/\[\[RECRUITER_CITY\]\]/gi, this.recruiter.city +',' ?? '')
         content = content.replace(/\[\[RECRUITER_STATECODE\]\]/gi, this.recruiter.stateCode + '&nbsp;&nbsp;' ?? '')
         content = content.replace(/\[\[RECRUITER_ZIPCODE\]\]/gi, this.recruiter.zipCode + '<br/>'?? '')

         // [[RECRUITER_ADDR_BLOCK]] The entire personal address block
         output = ''
         output += this.recruiter.address1 == undefined || this.recruiter.address1 == '' ? '' : this.recruiter.address1 + '<br />'
         output += this.recruiter.address2 == undefined || this.recruiter.address2 == '' ? '' : this.recruiter.address2 + '<br />'
         output += this.recruiter.city == undefined || this.recruiter.city == '' ? '' : this.recruiter.city
         if (this.recruiter.stateCode) {
            output += ', ' + this.recruiter.stateCode + '&nbsp;&nbsp;'
         }
         output += this.recruiter.zipCode == undefined || this.recruiter.zipCode == '' ? '' : this.recruiter.zipCode
         content = content.replace(/\[\[RECRUITER_ADDR_BLOCK\]\]/gi, output)

         // [[RECRUITER_PHONE]]
         content = content.replace(/\[\[RECRUITER_PHONE\]\]/gi, this.formatPhone(this.recruiter.phone))
         
         // -----------------------------------Agency Info
         // [[RECRUITER_AGENCY_ADDRESS1]]
         // [[RECRUITER_AGENCY_ADDRESS2]]
         // [[RECRUITER_AGENCY_CITY]]
         // [[RECRUITER_AGENCY_STATECODE]]
         // [[RECRUITER_AGENCY_ZIPCODE]]         
         content = content.replace(/\[\[RECRUITER_AGENCY_ADDRESS1\]\]/gi, this.recruiter.businessAddress1 ?? '')
         content = content.replace(/\[\[RECRUITER_AGENCY_ADDRESS2\]\]/gi, this.recruiter.businessAddress2 ?? '')
         content = content.replace(/\[\[RECRUITER_AGENCY_CITY\]\]/gi, this.recruiter.businessCity)
         content = content.replace(/\[\[RECRUITER_AGENCY_STATECODE\]\]/gi, this.recruiter.businessStateCode ?? '')
         content = content.replace(/\[\[RECRUITER_AGENCY_ZIPCODE\]\]/gi, this.recruiter.zipCode ?? '')

         // [[AGENCY_ADDR_BLOCK]] The entire personal address block
         output = ''
         output += this.recruiter.businessAddress1 == undefined || this.recruiter.businessAddress1 == '' ? '' : this.recruiter.businessAddress1 + '<br />'
         output += this.recruiter.businessAddress2 == undefined || this.recruiter.businessAddress2 == '' ? '' : this.recruiter.businessAddress2 + '<br />'
         output += this.recruiter.businessCity == undefined || this.recruiter.businessCity == '' ? '' : this.recruiter.businessCity
         if (this.recruiter.businessStateCode) {
            output += ', ' + this.recruiter.businessStateCode + '&nbsp;&nbsp;'
         }
         output += this.recruiter.businessZipCode == undefined || this.recruiter.businessZipCode == '' ? '' : this.recruiter.businessZipCode
         content = content.replace(/\[\[AGENCY_ADDR_BLOCK\]\]/gi, output)

         // [[RECRUITER_AGENCY_PHONE]]
         content = content.replace(/\[\[RECRUITER_AGENCY_PHONE\]\]/gi, this.recruiter.businessPhone ?? '')


         this.editor.commands.setContent(content, false)
      },
      formatPhone (phone) {
         if (!phone || phone == null) return ''
         return phone.replace(/[^0-9]/g, '')
      .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      }
   }

};
</script>

<style scoped lang="scss">
@import '../assets/css/colors.scss';
@import '../assets/css/email.scss';

form {
   width: 100%;
}
.btnw {
   min-width: 100px;
}
.under {
   font-style: italic;
   color: $corp-color;
}
</style>